'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var AppBar = require('@material-ui/core/AppBar');
var Toolbar = require('@material-ui/core/Toolbar');
var styles = require('@material-ui/core/styles');
var Typography = require('@material-ui/core/Typography');
var Divider = require('@material-ui/core/Divider');
var core = require('@material-ui/core');
var makeStyles = require('@material-ui/core/styles/makeStyles');
var Grid = require('@material-ui/core/Grid');
var ButtonBase = require('@material-ui/core/ButtonBase');
var AppsIcon = require('@material-ui/icons/Apps');
var IconButton = require('@material-ui/core/IconButton');
var Popper = require('@material-ui/core/Popper');
var ClickAwayListener = require('@material-ui/core/ClickAwayListener');
var Paper = require('@material-ui/core/Paper');
var MenuIcon = require('@material-ui/icons/Menu');
var LockIcon = require('@material-ui/icons/Lock');
var PowerSettingsNewIcon = require('@material-ui/icons/PowerSettingsNew');
var ContactSupportIcon = require('@material-ui/icons/ContactSupport');
var Avatar = require('@material-ui/core/Avatar');
var ListItemText = require('@material-ui/core/ListItemText');
var ListItem = require('@material-ui/core/ListItem');
var Button = require('@material-ui/core/Button');
var CreateIcon = require('@material-ui/icons/Create');
var Box = require('@material-ui/core/Box');
var List = require('@material-ui/core/List');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');
var SearchIcon = require('@material-ui/icons/Search');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AppBar__default = /*#__PURE__*/_interopDefaultLegacy(AppBar);
var Toolbar__default = /*#__PURE__*/_interopDefaultLegacy(Toolbar);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var makeStyles__default = /*#__PURE__*/_interopDefaultLegacy(makeStyles);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var AppsIcon__default = /*#__PURE__*/_interopDefaultLegacy(AppsIcon);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);
var ClickAwayListener__default = /*#__PURE__*/_interopDefaultLegacy(ClickAwayListener);
var Paper__default = /*#__PURE__*/_interopDefaultLegacy(Paper);
var MenuIcon__default = /*#__PURE__*/_interopDefaultLegacy(MenuIcon);
var LockIcon__default = /*#__PURE__*/_interopDefaultLegacy(LockIcon);
var PowerSettingsNewIcon__default = /*#__PURE__*/_interopDefaultLegacy(PowerSettingsNewIcon);
var ContactSupportIcon__default = /*#__PURE__*/_interopDefaultLegacy(ContactSupportIcon);
var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var CreateIcon__default = /*#__PURE__*/_interopDefaultLegacy(CreateIcon);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);
var List__default = /*#__PURE__*/_interopDefaultLegacy(List);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var SearchIcon__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon);

var AppHeaderContext = /*#__PURE__*/React.createContext({
  t: null
});

var AppHeader = function AppHeader(_ref) {
  var children = _ref.children,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor,
      _ref$translateHandler = _ref.translateHandler,
      translateHandler = _ref$translateHandler === void 0 ? null : _ref$translateHandler;
  var classes = useStyles$e({
    backgroundColor: backgroundColor
  });
  return /*#__PURE__*/React__default['default'].createElement(AppHeaderContext.Provider, {
    value: {
      t: translateHandler
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement(AppBar__default['default'], {
    position: "fixed",
    className: classes.appBar
  }, /*#__PURE__*/React__default['default'].createElement(Toolbar__default['default'], {
    className: classes.toolbar
  }, children))));
};
var useStyles$e = styles.makeStyles(function (theme) {
  return {
    root: {},
    appBar: {
      backgroundColor: function backgroundColor(props) {
        return props.backgroundColor ? props.backgroundColor : theme.palette.primary.main;
      }
    },
    toolbar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  };
});

var useStyles$d = core.makeStyles(function (theme) {
  return {
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      display: "flex",
      flexDirection: 'column',
      width: "320px"
    },
    avatar: {
      width: theme.spacing(9),
      height: theme.spacing(9),
      marginTop: theme.spacing(2),
      alignSelf: "center"
    },
    text: {
      alignSelf: "center"
    }
  };
});
var AppHeaderAppInfo = function AppHeaderAppInfo(_ref) {
  var app = _ref.app;
  var classes = useStyles$d();

  var AppIcon = function AppIcon(_ref2) {
    var icon = _ref2.icon,
        imageUrl = _ref2.imageUrl,
        title = _ref2.title;

    if (!icon && imageUrl) {
      return /*#__PURE__*/React__default['default'].createElement("img", {
        className: classes.img,
        src: imageUrl,
        alt: title
      });
    } else if (!icon) {
      return null;
    } else {
      return icon;
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement(AppIcon, {
    icon: app.icon,
    imageUrl: app.imageUrl,
    title: app.title
  }), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "subtitle1",
    className: classes.text
  }, app.title), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "body2",
    color: "textSecondary",
    className: classes.text
  }, app.version, " ", app.updatedAt)), /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null));
};

var AppHeaderApps = function AppHeaderApps(_ref) {
  var apps = _ref.apps,
      selectAppHandler = _ref.selectAppHandler;
  var classes = useStyles$c({
    size: 64
  });

  var getAppIcon = function getAppIcon(app) {
    return !app.icon && app.imageUrl ? /*#__PURE__*/React__default['default'].createElement("img", {
      className: classes.img,
      src: app.imageUrl,
      alt: app.title
    }) : app.icon;
  };

  if (!apps || !apps.length) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    className: classes.grid,
    container: true,
    spacing: 0
  }, apps.map(function (app) {
    return /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
      key: app.id,
      item: true,
      xs: 4
    }, /*#__PURE__*/React__default['default'].createElement(ButtonBase__default['default'], {
      className: classes.buttonBase,
      component: "figure",
      onClick: function onClick() {
        return selectAppHandler(app.url);
      }
    }, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
      className: classes.figure
    }, getAppIcon(app)), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
      className: classes.label,
      noWrap: true,
      align: "center"
    }, app.title)));
  })));
};
var useStyles$c = makeStyles__default['default'](function (theme) {
  return {
    grid: {
      flexGrow: 1,
      justifyContent: "flex-start",
      flexWrap: "wrap",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    buttonBase: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "transparent",
      color: "inherit"
    },
    figure: {
      width: function width(props) {
        return props.size;
      },
      height: function height(props) {
        return props.size;
      },
      margin: "12px",
      "& svg, & img": {
        boxSizing: "inherit",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        margin: "auto"
      }
    },
    label: {
      display: "block",
      fontSize: 12,
      marginTop: "-1em",
      width: "100%"
    }
  };
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useStyles$b = makeStyles__default['default'](function (theme) {
  return {
    popper: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      maxWidth: "320px",
      width: "320px"
    },
    button: {
      marginRight: theme.spacing(1)
    }
  };
});
var AppHeaderAppsNav = function AppHeaderAppsNav(_ref) {
  var children = _ref.children,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = React.useRef(null);
  var classes = useStyles$b();

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener__default['default'], {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    color: "inherit",
    "aria-label": "open appsmenu",
    edge: "start",
    onClick: function onClick() {
      return setOpen(function (d) {
        return !d;
      });
    },
    ref: anchorRef,
    className: classes.button
  }, /*#__PURE__*/React__default['default'].createElement(AppsIcon__default['default'], null)), /*#__PURE__*/React__default['default'].createElement(Popper__default['default'], {
    open: open,
    style: {
      zIndex: 2000
    },
    role: undefined,
    transition: true,
    disablePortal: false,
    anchorEl: anchorRef.current,
    placement: "bottom",
    arrow: {
      enabled: true,
      element: anchorRef
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.popper,
    "aria-expanded": open
  }, /*#__PURE__*/React__default['default'].createElement(Paper__default['default'], {
    elevation: 24,
    square: true
  }, children)))));
};

var AppHeaderDrawer = function AppHeaderDrawer(_ref) {
  var clickHandler = _ref.clickHandler,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var classes = useStyles$a();

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    color: "inherit",
    "aria-label": "open drawer",
    edge: "start",
    onClick: function onClick() {
      return clickHandler();
    },
    className: className ? className : classes.hamburger
  }, /*#__PURE__*/React__default['default'].createElement(MenuIcon__default['default'], null));
};
var useStyles$a = makeStyles__default['default'](function (theme) {
  var _hamburger;

  return {
    hamburger: (_hamburger = {}, _defineProperty(_hamburger, theme.breakpoints.up('sm'), {
      display: 'none'
    }), _defineProperty(_hamburger, "margin", 0), _hamburger)
  };
});

var AppHeaderLogin = function AppHeaderLogin(_ref) {
  var visible = _ref.visible,
      loginHandler = _ref.loginHandler;

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
    color: "inherit",
    "aria-label": "login",
    edge: "start",
    onClick: function onClick() {
      return loginHandler();
    }
  }, /*#__PURE__*/React__default['default'].createElement(LockIcon__default['default'], null));
};

var useStyles$9 = core.makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: 'row',
      justifyContent: "center"
    },
    button: {
      alignSelf: "center",
      maxWidth: "260px"
    }
  };
});
var AppHeaderLogout = function AppHeaderLogout(_ref) {
  var logoutHandler = _ref.logoutHandler;
  var classes = useStyles$9();
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    "aria-label": "logout",
    className: classes.button,
    onClick: function onClick() {
      return logoutHandler();
    }
  }, /*#__PURE__*/React__default['default'].createElement(PowerSettingsNewIcon__default['default'], {
    fontSize: "large"
  })), /*#__PURE__*/React__default['default'].createElement(IconButton__default['default'], {
    "aria-label": "support",
    className: classes.button,
    onClick: function onClick() {
      return window.open('https://kulturit.org/kontaktoss', '_blank');
    }
  }, /*#__PURE__*/React__default['default'].createElement(ContactSupportIcon__default['default'], {
    fontSize: "large"
  }))), /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null));
};

var AppHeaderMuseum = function AppHeaderMuseum(_ref) {
  var owner = _ref.owner,
      onSelect = _ref.onSelect;
  var classes = useStyles$8({
    backgroundColor: owner.theme.primaryColor
  });
  return /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], {
    button: true,
    onClick: function onClick() {
      return onSelect(parseInt(owner.uniqueId));
    }
  }, /*#__PURE__*/React__default['default'].createElement(core.ListItemAvatar, null, /*#__PURE__*/React__default['default'].createElement(Avatar__default['default'], {
    className: classes.avatar
  }, owner.abbr)), /*#__PURE__*/React__default['default'].createElement(ListItemText__default['default'], {
    primary: owner.title
  }));
};
var useStyles$8 = makeStyles__default['default'](function (theme) {
  return {
    avatar: {
      color: function color(props) {
        return theme.palette.getContrastText(props.backgroundColor);
      },
      backgroundColor: function backgroundColor(props) {
        return props.backgroundColor;
      },
      fontSize: "1rem"
    }
  };
});

var useStyles$7 = core.makeStyles(function (theme) {
  return {
    museumName: {
      paddingTop: theme.spacing(1)
    }
  };
});
var AppHeaderMuseumApps = function AppHeaderMuseumApps(_ref) {
  var museum = _ref.museum,
      clickHandler = _ref.clickHandler,
      selectAppHandler = _ref.selectAppHandler;
  var classes = useStyles$7();
  return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null), /*#__PURE__*/React__default['default'].createElement(Box__default['default'], {
    align: "center",
    className: classes.museumName
  }, /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    endIcon: /*#__PURE__*/React__default['default'].createElement(CreateIcon__default['default'], null),
    color: "primary",
    onClick: clickHandler
  }, museum.title)), /*#__PURE__*/React__default['default'].createElement(AppHeaderApps, {
    apps: museum.apps,
    selectAppHandler: selectAppHandler
  }));
};

var useAppHeaderContext = function useAppHeaderContext() {
  return React.useContext(AppHeaderContext);
};

var useTranslation = function useTranslation(_ref) {
  var key = _ref.key,
      defaultValue = _ref.defaultValue,
      options = _ref.options;

  var _useAppHeaderContext = useAppHeaderContext(),
      t = _useAppHeaderContext.t;

  if (t) {
    return t({
      key: key,
      defaultValue: defaultValue,
      options: options
    });
  } else {
    return key;
  }
};

var useStyles$6 = makeStyles__default['default'](function (theme) {
  return {
    search: {
      padding: "8px 16px 0px 16px",
      position: 'relative'
    },
    searchInput: {
      width: '100%'
    }
  };
});
var MuseumsSearch = function MuseumsSearch(_ref) {
  var searchQuery = _ref.searchQuery,
      setSearchQuery = _ref.setSearchQuery,
      museums = _ref.museums,
      isOverflow = _ref.isOverflow;
  var classes = useStyles$6();
  var translatedLabel = useTranslation({
    key: 'navigation:filterMuseums.searchText',
    defaultValue: 'Søk blant {{count}} museer',
    options: {
      count: museums.length
    }
  });

  if (isOverflow || searchQuery) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.search
    }, /*#__PURE__*/React__default['default'].createElement(TextField__default['default'], {
      className: classes.searchInput,
      id: "filled-search",
      label: translatedLabel,
      type: "search",
      variant: "outlined",
      onChange: function onChange(event) {
        return setSearchQuery(event.target.value);
      },
      value: searchQuery,
      InputProps: {
        endAdornment: /*#__PURE__*/React__default['default'].createElement(InputAdornment__default['default'], {
          position: "end"
        }, /*#__PURE__*/React__default['default'].createElement(SearchIcon__default['default'], null))
      }
    }));
  } else {
    return null;
  }
};

var useOverflowListener = function useOverflowListener(_ref) {
  var target = _ref.target,
      searchQuery = _ref.searchQuery;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      overflow = _useState2[0],
      setOverflow = _useState2[1];

  React.useEffect(function () {
    if (target && target.current) {
      var handleOverflow = function handleOverflow() {
        setOverflow(target.current.offsetHeight < target.current.scrollHeight);
      };

      handleOverflow();
      window.addEventListener('resize', handleOverflow);
      return function () {
        window.removeEventListener('resize', handleOverflow);
      };
    }
  }, [target]);
  React.useEffect(function () {
    if (target && target.current) {
      var handleOverflow = function handleOverflow() {
        setOverflow(target.current.offsetHeight < target.current.scrollHeight);
      };

      handleOverflow();
    }
  }, [target, searchQuery]);
  return overflow;
};

var useStyles$5 = makeStyles__default['default'](function () {
  return {
    ownersList: {
      maxHeight: '35vh',
      overflowY: function overflowY(props) {
        return props.isOverflow ? "scroll" : 'visible';
      },
      overflowX: 'hidden'
    }
  };
});
var MuseumsList = function MuseumsList(_ref) {
  var searchQuery = _ref.searchQuery,
      setSearchQuery = _ref.setSearchQuery,
      museums = _ref.museums,
      selectMuseumHandler = _ref.selectMuseumHandler;
  var ownersBoxRef = React.useRef();
  var isOverflow = useOverflowListener({
    target: ownersBoxRef,
    searchQuery: searchQuery
  });
  var classes = useStyles$5({
    isOverflow: isOverflow
  });
  var filteredOwners = searchQuery ? museums.filter(function (owner) {
    return owner.title.toLowerCase().includes(searchQuery.toLowerCase());
  }) : museums;
  return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, museums && museums.length ? /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null) : null, /*#__PURE__*/React__default['default'].createElement(MuseumsSearch, {
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    museums: museums,
    isOverflow: isOverflow
  }), /*#__PURE__*/React__default['default'].createElement(Box__default['default'], {
    className: classes.ownersList,
    ref: ownersBoxRef
  }, /*#__PURE__*/React__default['default'].createElement(List__default['default'], null, filteredOwners.sort(function (a, b) {
    return a.title.localeCompare(b.title);
  }).map(function (owner) {
    return /*#__PURE__*/React__default['default'].createElement(AppHeaderMuseum, {
      key: owner.uniqueId,
      owner: owner,
      onSelect: selectMuseumHandler
    });
  }))));
};

var AppHeaderMuseums = function AppHeaderMuseums(_ref) {
  var museums = _ref.museums,
      preSelectMuseum = _ref.preSelectMuseum,
      selectAppHandler = _ref.selectAppHandler;

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var _useState3 = React.useState(preSelectMuseum),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedMuseum = _useState4[0],
      setSelectedMuseum = _useState4[1];

  if (museums.find(function (museum) {
    return parseInt(museum.uniqueId) === selectedMuseum;
  })) {
    return /*#__PURE__*/React__default['default'].createElement(AppHeaderMuseumApps, {
      museum: museums.find(function (museum) {
        return parseInt(museum.uniqueId) === selectedMuseum;
      }),
      clickHandler: function clickHandler() {
        return setSelectedMuseum(null);
      },
      selectAppHandler: selectAppHandler
    });
  } else {
    return /*#__PURE__*/React__default['default'].createElement(MuseumsList, {
      museums: museums,
      searchQuery: searchQuery,
      selectMuseumHandler: setSelectedMuseum,
      setSearchQuery: setSearchQuery
    });
  }
};

var useStyles$4 = core.makeStyles(function (theme) {
  return {
    search: _defineProperty({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      marginLeft: 0,
      marginRight: theme.spacing(2),
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }),
    inputRoot: {
      color: 'inherit',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: core.fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: core.fade(theme.palette.common.white, 0.25)
      }
    },
    inputInput: _defineProperty({
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: "1em",
      transition: theme.transitions.create('width'),
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: '12ch',
      '&:focus': {
        width: '20ch'
      }
    })
  };
});
var AppHeaderSearch = function AppHeaderSearch(_ref) {
  var onSearch = _ref.onSearch,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? null : _ref$onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  var classes = useStyles$4();

  var _useState = React.useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchString = _useState2[0],
      setSearchString = _useState2[1];

  var changeHandler = function changeHandler(event) {
    var newValue = event.target.value;

    if (onChange) {
      onChange(newValue);
    } else {
      setSearchString(newValue);
    }
  };

  var searchHandler = function searchHandler() {
    if (!onSearch) {
      throw new Error('required onSearch prop is not set. ');
    } else {
      onSearch(getValue());
    }
  };

  var keyPressHandler = function keyPressHandler(event) {
    if ('Enter' === event.key) {
      searchHandler();
    }
  };

  var getValue = function getValue() {
    return value ? value : searchString;
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.search
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.Input, {
    value: getValue(),
    onChange: changeHandler,
    placeholder: placeholder ? placeholder : "Search...",
    disableUnderline: true,
    onKeyPress: keyPressHandler,
    classes: {
      root: classes.inputRoot,
      input: classes.inputInput
    },
    endAdornment: /*#__PURE__*/React__default['default'].createElement(core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
      color: "inherit",
      onClick: searchHandler
    }, /*#__PURE__*/React__default['default'].createElement(SearchIcon__default['default'], null)))
  })));
};

var AppHeaderTitle = function AppHeaderTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  var classes = useStyles$3();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.titleContent
  }, /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "body1",
    component: "h1",
    className: classes.title
  }, title), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "body1",
    component: "h2",
    className: classes.subtitle
  }, subtitle));
};
var useStyles$3 = core.makeStyles(function (theme) {
  return {
    title: {
      fontWeight: "bold"
    },
    titleContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      overflow: "hidden"
    },
    subtitle: {
      maxHeight: theme.spacing(3),
      overflow: "hidden"
    }
  };
});

var useStyles$2 = core.makeStyles(function (theme) {
  return {
    titleContent: {
      display: "flex",
      justifyContent: "space-between",
      flexGrow: 1,
      overflow: "hidden",
      marginLeft: theme.spacing(1)
    }
  };
});
var AppHeaderTitleContainer = function AppHeaderTitleContainer(_ref) {
  var children = _ref.children;
  var classes = useStyles$2();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.titleContent
  }, children);
};

var useStyles$1 = core.makeStyles(function (theme) {
  return {
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      display: "flex",
      flexDirection: 'column',
      width: "320px"
    },
    avatar: {
      width: theme.spacing(9),
      height: theme.spacing(9),
      marginTop: theme.spacing(2),
      alignSelf: "center"
    },
    text: {
      alignSelf: "center"
    }
  };
});
var AppHeaderUserInfo = function AppHeaderUserInfo(_ref) {
  var user = _ref.user;
  var classes = useStyles$1();
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement(Avatar__default['default'], {
    alt: user.name,
    src: user.imageUrl,
    className: classes.avatar
  }), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "subtitle1",
    className: classes.text
  }, user.name), /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "body2",
    color: "textSecondary",
    className: classes.text
  }, user.email)), /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null));
};

var useStyles = makeStyles__default['default'](function (theme) {
  return {
    root: {
      marginTop: '6px',
      marginBottom: '6px',
      maxWidth: "320px"
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4)
    }
  };
});
var AppHeaderUserNav = function AppHeaderUserNav(_ref) {
  var user = _ref.user,
      children = _ref.children,
      visible = _ref.visible;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = React.useRef(null);
  var classes = useStyles();

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener__default['default'], {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
    color: "inherit",
    "aria-label": "open usermenu",
    edge: "start",
    onClick: function onClick() {
      return setOpen(function (d) {
        return !d;
      });
    },
    ref: anchorRef
  }, /*#__PURE__*/React__default['default'].createElement(Avatar__default['default'], {
    alt: user.name,
    src: user.imageUrl,
    className: classes.avatar
  })), /*#__PURE__*/React__default['default'].createElement(Popper__default['default'], {
    open: open,
    style: {
      zIndex: 2000
    },
    role: undefined,
    transition: true,
    disablePortal: false,
    anchorEl: anchorRef.current,
    placement: "bottom",
    arrow: {
      enabled: true,
      element: anchorRef
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root,
    "aria-expanded": open
  }, /*#__PURE__*/React__default['default'].createElement(Paper__default['default'], {
    elevation: 24,
    square: true
  }, children)))));
};

var withAppHeader = function withAppHeader(storyFn) {
  return /*#__PURE__*/React__default['default'].createElement(AppHeader, null, storyFn());
};

exports.AppHeader = AppHeader;
exports.AppHeaderAppInfo = AppHeaderAppInfo;
exports.AppHeaderApps = AppHeaderApps;
exports.AppHeaderAppsNav = AppHeaderAppsNav;
exports.AppHeaderDrawer = AppHeaderDrawer;
exports.AppHeaderLogin = AppHeaderLogin;
exports.AppHeaderLogout = AppHeaderLogout;
exports.AppHeaderMuseum = AppHeaderMuseum;
exports.AppHeaderMuseumApps = AppHeaderMuseumApps;
exports.AppHeaderMuseums = AppHeaderMuseums;
exports.AppHeaderSearch = AppHeaderSearch;
exports.AppHeaderTitle = AppHeaderTitle;
exports.AppHeaderTitleContainer = AppHeaderTitleContainer;
exports.AppHeaderUserInfo = AppHeaderUserInfo;
exports.AppHeaderUserNav = AppHeaderUserNav;
exports.withAppHeader = withAppHeader;
//# sourceMappingURL=index.js.map
